import { render, staticRenderFns } from "./GiftBagIcon.vue?vue&type=template&id=2624f925&"
import script from "./GiftBagIcon.vue?vue&type=script&lang=js&"
export * from "./GiftBagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports